// Creator HQ
import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import DashboardQuickActions from "../components/DashboardQuickActions";
import LiveKitSetupCard from "../components/LiveKitSetupCard";
import { TrendingUp, Eye, DollarSign, Users, Upload, Sparkles, User as UserIcon } from "lucide-react";
import { Link } from "react-router-dom";

export default function CreatorHQ() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  useEffect(() => { if (user) api.get("/creator/overview").then(({ data }) => setData(data)); }, [user]);

  if (!user) return <div className="p-20 text-center text-white/40">Sign in as a creator.</div>;
  if (!data) return <div className="text-white/40">Loading…</div>;

  return (
    <div className="surface-light max-w-[1500px] mx-auto space-y-10" data-testid="creator-hq">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="label-eyebrow mb-3">// creator hq</div>
          <h1 className="font-display font-black text-4xl lg:text-6xl tracking-tighter">{user.display_name}</h1>
          <DashboardQuickActions className="mt-3" />
          <div className="text-[11px] tracking-[0.3em] uppercase text-nexus-cyan mt-2">Level {data.level} · {data.xp} XP · {data.vp} VP</div>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <Link to={`/u/${user.id}`} className="btn-ghost rounded-full" data-testid="view-profile-btn"><UserIcon className="w-3.5 h-3.5" /> View profile</Link>
          <button className="btn-nexus" data-testid="upload-btn"><Upload className="w-3.5 h-3.5" /> Upload BReel</button>
        </div>
      </div>

      <LiveKitSetupCard compact subtitle="Connect your LiveKit Cloud project to go live. Auto-rotates on quota." />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/5">
        {[
          { l: "Earnings", v: `$${data.earnings.toFixed(2)}`, i: DollarSign },
          { l: "Balance", v: `${data.balance.toFixed(0)} NX`, i: DollarSign },
          { l: "Followers", v: data.followers, i: Users },
          { l: "Subscribers", v: data.subscribers, i: TrendingUp },
        ].map((c) => (
          <div key={c.l} className="bg-nexus-surface p-6">
            <c.i className="w-5 h-5 text-nexus-cyan mb-3" />
            <div className="label-eyebrow">{c.l}</div>
            <div className="font-display font-black text-3xl mt-2">{c.v}</div>
          </div>
        ))}
      </div>

      <section className="space-y-4">
        <h2 className="font-display text-sm tracking-[0.3em] uppercase">Your Streams</h2>
        <div className="space-y-px bg-white/5">
          {data.streams.length === 0 && <div className="bg-nexus-surface p-6 text-white/40 text-sm">No streams yet. Press upload to start.</div>}
          {data.streams.map((s) => (
            <div key={s.id} className="bg-nexus-surface p-5 flex items-center gap-4">
              <img src={s.thumbnail} alt="" className="w-24 aspect-video object-cover" />
              <div className="flex-1">
                <div className="text-sm font-medium">{s.title}</div>
                <div className="text-[11px] text-white/40 mt-1">{s.viewers.toLocaleString()} viewers</div>
              </div>
              <div className="text-xs text-nexus-cyan font-mono">${s.total_tips.toFixed(2)}</div>
              {s.is_live && <div className="bg-nexus-crimson/95 px-2 py-1 text-[9px] tracking-[0.3em] font-display uppercase">Live</div>}
            </div>
          ))}
        </div>
      </section>

      <section className="glass p-6">
        <div className="flex items-center gap-2"><Sparkles className="w-4 h-4 text-nexus-cyan" /><div className="label-eyebrow">// ed3n suggests</div></div>
        <p className="mt-3 text-sm text-white/70">Open ED3N (bottom right) and ask "Give me 5 stream title ideas for tonight" or "What's my growth strategy?"</p>
      </section>
    </div>
  );
}
